import ahCawCommons from '@sparta.authglobal.utilities/ah-common-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n\r\n\r\n\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.authhelper.modules/ah-widget-loader-module",
  "version": "1.1.2",
  "id": "ahWidgetLoaderModule",
  "containerID": "authhelperAhWidgetLoaderModule",
  "moduleName": "authhelper-ah-widget-loader-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "ah-widget-loader-module",
  "data": {
    "init": "AhWidgetLoaderModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "color",
    "type": "string",
    "description": "This parameter controls the general color scheme of module. The default is blue, but you can also choose red or green.",
    "default": "blue",
    "values": ["red", "green", "blue"]
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.x.x",
    "@sparta.authglobal.utilities/ah-common-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * Implementation of the ah-widget-loader-module module.
 * @copyright 2020-8-19
 * @since 8/19/2020, 2:38:10 PM
 * @author zkos9ab
 * @file
 */

const LOADER_VERSION_LIST = {
  'sparta_V5_secure-ah-omni-channel-auth-widget_2.0.0': '2.3.4',
  'sparta_V5_secure-ah-omni-channel-auth-widget_3.0.0': '5.3.1',
  'sparta_V5_ml-ah-omni-channel-auth-widget_1.0.0': '2.3.4',
  'sparta_V5_pb-ah-omni-channel-auth-widget_1.0.0': '2.3.4',
  'sparta_V5_secure-stepup-widget_2.0.0': '5.3.1',
  sparta_V6: '6.0.0'
};
const SPARTA_EVENTS = {
  WIDGET_READY: 'SPARTA_WIDGET_READY.spartaWidgetUtility',
  V5_WIDGET_LOADER: 'SECURE_AH_V5_WIDGET_LOADER',
  V6_WIDGET_LOADER: 'SECURE_AH_V6_WIDGET_LOADER',
  V6_WIDGET_LOADER_READY: 'SPARTA_AH_V6_WIDGET_LOADER_READY',
  V5_WIDGET_LOADER_READY: 'SPARTA_AH_V5_WIDGET_LOADER_READY'
};
const widgetsInitName = 'widgets.initialWidgetLoader';
/**
 * The AhWidgetLoaderModule Sparta Module.
 * poc module
 * @export
 * @class
 */
class AhWidgetLoaderModule extends Module {
  /**
   * Creates an instance of AhWidgetLoaderModule.
   * @memberof AhWidgetLoaderModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.basePath = ahCawCommons.getBasePath(this.spaParams);
  }

  /**
    * @function _defineVars
    * @description  Called when the default variables are declared.
    * @returns {undefined}
  */
  _defineVars() {
    this.WIDGET_CONFIG = {};
    this.WIDGET_PARAMS = {};
    this.widgetLoadedList = {};
  }

  /**
   * @function _getObjectValue
   * @description  Validate & return the the specific child key value of an Object.
   * @param {object} inputObject Object to validate.
   * @param {string} keyflows child flow keys.
   * @returns {string | object | Array | undefined} It will return the output of the key which requested.
   */
  _getObjectValue(inputObject = {}, keyflows) {
    const pathArray = Array.isArray(keyflows) ? keyflows : keyflows.match(/([^[.\]])+/g);
    return pathArray.reduce((prevObj, key) => prevObj && prevObj[key], inputObject);
  }

  /**
   * @function _getBaseUrl
   * @description  Called to get the baseurl based on the conditions check.
   * @returns {string } It will return the baseurl to generate the widget.
   */
  _getBaseUrl() {
    const {
      widgetBaseURL
    } = this.WIDGET_CONFIG;
    if (widgetBaseURL) {
      return widgetBaseURL;
    }
    if (this.basePath) {
      return window.__swl && window.__swl.basePath ? window.__swl.basePath : this.basePath;
    }
    return window.location.origin;
  }

  /**
   * @function _triggerWidgetLoaderScript
   * @description  It will generate the script tag and load the sparta widget javascript file.
   * @returns {undefined }
   */
  _triggerWidgetLoaderScript() {
    const loader = document.createElement('script');
    loader.type = 'text/javascript';
    loader.src = this._getSpartaWidgetJSPath();
    loader.dataset.widgetName = widgetsInitName;
    loader.onload = this._spartaLoaderInitialized.bind(this);
    document.body.appendChild(loader);
  }

  /**
   * @function _getLoaderVersion
   * @description  It will check the widget config to retrieve the corresponding sparta loader version.
   * @returns {string } It will return the loader version.
   */
  _getLoaderVersion() {
    const {
      spartaV6,
      widgetName,
      widgetVersion,
      spartaLoaderVersion
    } = this.WIDGET_CONFIG;
    const loadVersionKey = spartaV6 ? 'sparta_V6' : `sparta_V5_${widgetName}_${widgetVersion}`;
    return spartaLoaderVersion || LOADER_VERSION_LIST[loadVersionKey];
  }

  /**
   * @function _getSpartaWidgetJSPath
   * @description  It will generate the sparta widget loader js url based on the widget config.
   * @returns {String} Returns the sparta widget loader js url path.
   */
  _getSpartaWidgetJSPath() {
    const widgetBaseURL = this._getBaseUrl();
    const LOADER_VERSION = this._getLoaderVersion();
    return `${widgetBaseURL}/spa/widgets/loader/${LOADER_VERSION}/index.js`;
  }

  /**
   * @function _extractHtmlLang
   * @description  It will retrive the language based on the HTML tag element.
   * @returns {String} Returns value from lang param from HTML.
   */
  _extractHtmlLang() {
    let htmlLang = document.querySelector('html').getAttribute('lang');
    if (htmlLang && htmlLang.length > 0) {
      htmlLang = htmlLang.toLowerCase();
      htmlLang = htmlLang.replace(/_/g, '-');
      const hyphenIndex = htmlLang.indexOf('-');
      if (hyphenIndex !== -1) {
        htmlLang = htmlLang.substring(0, hyphenIndex);
      }
    }
    return htmlLang;
  }

  /**
   * @function _getWidgetLoadConfig
   * @description  It will retrive widget loader config based on the client provided widget config.
   * @returns {Object} Returns the loader config.
   */
  _getWidgetLoadConfig() {
    const {
      widgetName,
      widgetVersion,
      containerId,
      language = this._extractHtmlLang(),
      options = {},
      spinner
    } = this.WIDGET_CONFIG;
    return {
      name: widgetName,
      // Widget name
      version: widgetVersion,
      // Widget version
      loaderVersion: this._getLoaderVersion(),
      container: containerId,
      // ID of the element the widget will be loaded into
      path: this._getBaseUrl(),
      // Base path to CDN/widget location
      language,
      // Display language specific widget
      spinner: !!spinner,
      // Defaults to true; will display a spinner in the id while
      options,
      onload: this._spartaLoaderLoaded.bind(this) // Your callback once your widget is ready
    };
  }

  /**
   * @function _isV5LoaderVersion
   * @description  It will validate whether the provided version is belongs to v5 loader.
   * @param {string} version Loader version detail.
   * @returns {Boolean} It will return whether the version is belong to v5 loader or not.
   */
  _isV5LoaderVersion() {
    const LOADER_VERSION = this._getLoaderVersion();
    const majorVersionNumber = LOADER_VERSION.split('.')[0];
    return majorVersionNumber === '5';
  }

  /**
   * @function _spartaLoaderInitialized
   * @description  It will trigger the widget loader `load` function based on the widget config.
   * @returns {undefined}
   */
  _spartaLoaderInitialized() {
    // let that = this;
    const {
      spartaV6
    } = this.WIDGET_CONFIG;
    const LOADER_VERSION = this._getLoaderVersion();
    const widgetLoaderConfig = this._getWidgetLoadConfig();
    const isSpartaV5 = this._isV5LoaderVersion();
    if (isSpartaV5) {
      window.sparta.widgets[LOADER_VERSION].load(widgetLoaderConfig);
    } else if (spartaV6) {
      /* These approach is for temporarly used in PB
      widgetLoaderConfig.options = {
        data: {
          configPayload: this.WIDGET_CONFIG.payload
        }
      }
      */
      window.sparta.widgetLoader[LOADER_VERSION].load(widgetLoaderConfig);

      /**
       * SetTimeout is removed as it affects the widget reload as the widget instance is available in Sparta
       * Widget ready is getting triggered before it get subscribed
       */

      this._spartaV6LoaderLoaded(widgetLoaderConfig);
    } else {
      window.sparta.widgetLoader.load(widgetLoaderConfig);
      this._spartaLoaderLoaded(window.sparta.widgetLoader);
    }
  }

  /**
   * @function _checkLoaderScriptTriggered
   * @description  It will verify whether the sparta widget loader js is loaded or not.
   * @returns {Boolean} widget loader is loaded or not.
   */
  _checkLoaderScriptTriggered() {
    const {
      spartaV6
    } = this.WIDGET_CONFIG;
    const LOADER_VERSION = this._getLoaderVersion();
    let isScriptLoaded = false;
    const isSpartaV5 = this._isV5LoaderVersion();
    if (isSpartaV5) {
      isScriptLoaded = !!this._getObjectValue(window.sparta, `widgets.${LOADER_VERSION}.load`);
    } else if (spartaV6) {
      isScriptLoaded = !!this._getObjectValue(window.sparta, `widgetLoader.${LOADER_VERSION}.load`);
    } else {
      isScriptLoaded = !!this._getObjectValue(window.sparta, 'widgetLoader.load');
    }
    this._debug('isScriptLoaded', isScriptLoaded);
    return isScriptLoaded;
  }

  /**
   * @function _spartaLoaderLoaded
   * @description  It will get triggered when the sparta loader js is loaded and this function will dispatch the loader ready event to client.
   * @param {Object} myWidget It contains the widgetInstance which helps to trigger pub/sub for communication.
   * @returns {undefined}
   */
  _spartaLoaderLoaded(myWidget) {
    this._debug('::myWidget', myWidget);
    const LOADER_VERSION = this._getLoaderVersion();

    /** Deprecated Native Events, Used for backward compatibility support */
    const event = new CustomEvent(SPARTA_EVENTS.V5_WIDGET_LOADER_READY, {
      detail: {
        widgetLoader: myWidget,
        loaderVersion: LOADER_VERSION
      }
    });
    document.dispatchEvent(event); // send handle back to the client for pub/sub communication
    /****** */

    this.Events.pub(SPARTA_EVENTS.V5_WIDGET_LOADER_READY, {
      widgetLoader: myWidget,
      loaderVersion: LOADER_VERSION
    });
    this._subscribeWidgetEvents(myWidget);
  }

  /**
   * @function _spartaV6LoaderLoaded
   * @description  It will get triggered after the sparta v6 loader load function is triggered
   * and its tactical solution to generate the widgetinstance and send to client.
   * @param {Object} myWidget It contains the widgetloaderConfig.
   * @returns {undefined}
   */
  _spartaV6LoaderLoaded(myWidget) {
    const LOADER_VERSION = this._getLoaderVersion();
    const container = document.getElementById(myWidget.container) || myWidget.container;
    const widgetInstances = {};
    widgetInstances.events = {
      pub(eventName, detail = {}) {
        if (!detail.widget || detail.widget.id === container.id) {
          const evt = new CustomEvent(eventName, {
            detail
          });
          container.dispatchEvent(evt);
        }
      },
      // attaches an event listener to our DispatcherElement
      sub(eventName, callback) {
        container.addEventListener(eventName, callback);
      }
    };
    this.Events.pub(SPARTA_EVENTS.V6_WIDGET_LOADER_READY, {
      widgetLoader: widgetInstances,
      loaderVersion: LOADER_VERSION
    });
    this._subscribeWidgetEvents(widgetInstances);
  }

  /**
   * @function _subscribeWidgetEvents
   * @description  It will subscribe the sparta loader event.
   * @param {Object} myWidget loader events for pub/sub.
   * @returns {undefined}
   */
  _subscribeWidgetEvents(myWidget) {
    const main = this;
    const myWidgetEvent = myWidget.events ? myWidget.events : myWidget;
    myWidgetEvent.sub(SPARTA_EVENTS.WIDGET_READY, e => {
      main._debug(`SPARTA_WIDGET_READY loaded/refreshed: ${JSON.stringify(e.detail)}`);
      const {
        widgetName,
        containerId
      } = main.WIDGET_CONFIG;
      if (!main.WIDGET_CONFIG) {
        main._debug('NATIVE: Sparta widget not prepared yet');
        return;
      }
      main._debug('NATIVE: Sparta widget is prepared, ready event received');
      if (e.detail.widget.name === widgetName) {
        const _widgetParams = main.WIDGET_PARAMS;
        document.getElementById(containerId).style.visibility = 'visible';
        myWidgetEvent.pub(_widgetParams.eventName, _widgetParams.payload);
      }
      main.selfInitialized = true;
    });
  }

  /**
   * @function _subscribeEvents
   * @description  All subscribe events will added.
   * @returns {undefined}
   */
  _subscribeEvents() {
    this.Events.sub(SPARTA_EVENTS.V5_WIDGET_LOADER, this._triggerWidgetLoaderInitalization.bind(this), true);
    this.Events.sub(SPARTA_EVENTS.V6_WIDGET_LOADER, this._triggerWidgetLoaderInitalization.bind(this), true);
  }

  /**
   * @function _triggerWidgetLoaderInitalization
   * @description  It will be loader initatlization from the widget loader event publish from the client.
   * @param {Object} event Event returned values.
   * @returns {undefined}
   */
  _triggerWidgetLoaderInitalization(event) {
    this._debug(':Widget Config:', event.data);
    /**
     * Deep cloning the widget config to prevent the base object values change
     * due to key value update inside the widget
     */
    const config = JSON.parse(JSON.stringify(event.data || {}));
    const {
      widgetVersion,
      widgetName
    } = config;
    const widgetInfo = `${widgetName}_${widgetVersion}`;

    // It helps to prevent the multiple event trigger in short span of time
    if (this.widgetLoadedList[widgetInfo]) {
      return;
    }
    this.WIDGET_CONFIG = {
      ...config,
      containerId: config.containerId || config.ContainerId
    };
    this.WIDGET_PARAMS = {
      eventName: config.widgetEventName,
      payload: config.payload
    };
    const isLoaderScriptTriggered = this._checkLoaderScriptTriggered();
    this.widgetLoadedList[widgetInfo] = true;
    if (isLoaderScriptTriggered) {
      this._spartaLoaderInitialized();
    } else {
      this._triggerWidgetLoaderScript();
    }
    window.setTimeout(() => {
      this.widgetLoadedList[widgetInfo] = false;
    }, 500);
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {undefined}
   */
  init() {
    this._defineVars();
    this._subscribeEvents();
  }

  /**
   * Called when debugging console logs need to populate.
   * @param {string} msg Log message.
   * @returns {undefined}
   */
  _debug(msg) {
    if (window.console && this._debugEnabled) {
      console.log('ah-widget-loader-v6', msg);
    }
  }
}
registerModuleClass({
  moduleClass: AhWidgetLoaderModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { AhWidgetLoaderModule as default, moduleConfig };
